import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { reclaimDisputeRowSchema } from "./get-reclaim-disputes";

/**
 * Drill-down list for the "generation overdue" bucket on the Pipeline
 * Health tab. Reuses the standard reclaim-dispute row so the admin tab
 * can use the same table component as the main Disputes tab.
 *
 * Total count for pagination is sourced from `getReclaimPipelineHealth`
 * (the panel already calls it for the card) so this RPC stays a pure
 * list endpoint — same separation as `getReclaimDisputes` /
 * `getReclaimDisputesCount`.
 */
export const getReclaimGenerationOverdueDisputes = unaryRpc({
  name: "getReclaimGenerationOverdueDisputes" as const,
  input: z.object({
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
  }),
  output: z.object({ disputes: z.array(reclaimDisputeRowSchema) }),
});
